import { GoogleMapsConfigService } from '@/common/infrastructure/services/GoogleMapsConfigService';
import { LoggerService } from '@/common/infrastructure/services/LoggerService';

const logger = LoggerService.create('GoogleMapsApiKey');

/**
 * Get Google Maps API key from configuration service
 * This utility function safely retrieves the API key and returns undefined if not configured
 * @returns Google Maps API key or undefined if not available
 */
export function getGoogleMapsApiKey(): string | undefined {
  try {
    return GoogleMapsConfigService.getInstance().getApiKey();
  } catch (e) {
    logger.error('Failed to retrieve Google Maps API key', e);
    return undefined;
  }
}
